module.exports = __webpack_public_path__ + "static/media/video.b55e25ba.webm";